export const cards = ['A', '2', '3', '4', '5', '6', '7', '8', '9', '10', 'J', 'Q', 'K']
export const suits = { clubs: '♣', hearts: '♥', spades: '♠', diamonds: '♦' }

export function takeACard () {
  const index = Math.floor(Math.random() * cards.length)
  const suit = Object.keys(suits)[Math.floor(Math.random() * Object.keys(suits).length)]

  return { numeric: index + 1, suit, value: cards[index], icon: suits[suit] }
}
